// extracted by mini-css-extract-plugin
module.exports = {"container":"SnackbarContainer_container_1uxgx","front":"SnackbarContainer_front_2oOPq"};